import style from './menu.module.css';

const Menu = () => {
  return (
    <svg
      className={style.menu}
      fill="none"
      height="26"
      viewBox="0 0 31 26"
      width="31"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        stroke="currentColor"
        x2="31"
        y1="0.5"
        y2="0.5"
      />
      <line
        stroke="currentColor"
        x2="31"
        y1="12.5"
        y2="12.5"
      />
      <line
        stroke="currentColor"
        x2="31"
        y1="25.5"
        y2="25.5"
      />
    </svg>
  );
};

export default Menu;
